import { RestLink } from 'apollo-link-rest';
import { ApolloLink } from '@apollo/client';
import { getAppSetting } from '../../../../Shared/ApplicationSettings';
import { ApolloClient, InMemoryCache } from '@apollo/client';

// Authorization
const authLink = new ApolloLink((operation, forward) => {
  const customHeaders = operation.getContext().hasOwnProperty('headers')
    ? operation.getContext().headers
    : {};

  operation.setContext({
    headers: {
      authorization: `Bearer ${localStorage.getItem('access_token')}`,
      ...customHeaders
    }
  });

  return forward(operation);
});

// Print Order API
const configuredRestLink = (endpointUri): any => {
  return new RestLink({
    uri: endpointUri
  });
};

const printCache = new InMemoryCache();
export const printApiRestClient = new ApolloClient({
  cache: printCache,
  link: authLink.concat(
    configuredRestLink(getAppSetting('PRINT_ORDER_SERVICE_URL'))
  )
});

const usersCache = new InMemoryCache();

export const usersApiRestClient = new ApolloClient({
  cache: usersCache,
  link: authLink.concat(configuredRestLink(getAppSetting('USERS_API_URL')))
});
